import React, {Component} from "react";
import NotificationMessagesView from "./NotificationMessagesView";
import {NotificationMessagesService} from "../../service/notificationMessages/NotificationMessagesService";
import {Button} from "primereact/button";
import {Card} from "primereact/card";
import SubtitleLabel from "../Title/SubtitleLabel/SubtitleLabelView";
import {Growl} from "primereact/growl";

export default class NotificationMessagesContainer extends Component {
    constructor(props) {
        super(props);
        this.notificationMessagesService = new NotificationMessagesService();

        this.state = {
            isNotificationMessage: false,
            isLoading: true,
            notificationList: [],
        }

        this.getNotificationMessage = this.getNotificationMessage.bind(this);
        this.getDetailsNotificationMessage = this.getDetailsNotificationMessage.bind(this);
        this.acceptNotification = this.acceptNotification.bind(this);
        this.getNotificationTemplate = this.getNotificationTemplate.bind(this);
        this.onHide = this.onHide.bind(this);

    }

    onHide() {
        localStorage.setItem("notificationMessage", '');
        this.setState({
            isNotificationMessage: false,
        });
    }

    componentDidMount() {
        let isNotificationMessage = localStorage.getItem("notificationMessage") ?
            localStorage.getItem("notificationMessage") === "notificationMessage" : false;
        this.setState({
            isNotificationMessage: isNotificationMessage,
        });
        if (isNotificationMessage) {
            this.getNotificationMessage();
        }
    }


    getNotificationMessage(){
        this.notificationMessagesService.getNotificationMessage().then(
            resp => {
                let notificationList = resp.payload;
                if(notificationList.length > 0){
                    this.getDetailsNotificationMessage(notificationList);
                }else {
                    localStorage.setItem("notificationMessage", '');
                    this.setState({
                        isNotificationMessage: false,
                    })
                }
            });
    }

    getDetailsNotificationMessage(idNotificationList){
        idNotificationList.forEach(item => {
            this.notificationMessagesService.getDetailNotificationMessage(item.id).then(
                resp => {
                    item['descripcion'] = resp.payload.length > 0 ? resp.payload[0]['titulo'] : '';
                    this.setState({
                        notificationList: idNotificationList,
                        isLoading: false,
                    });
                });
        });
    }
    acceptNotification(e){
        let id = Number(e.currentTarget.id);
        let notificationListAux = this.state.notificationList;
        let elemRemoved = notificationListAux.splice(id,  1);
        this.setState({
            isLoading: true,
        });
        this.notificationMessagesService.acceptNotificationMessage(elemRemoved[0].id).then(
            resp => {
                if (resp.message === 'Success') {
                    this.growl.show({severity: 'success', summary: 'Éxito.',
                        detail: 'Su respuesta se ha guardado exitosamente.'});
                    this.setState({
                        notificationList: notificationListAux,
                        isNotificationMessage: notificationListAux.length > 0,
                    });
                } else if (resp.error !== '') {
                    this.growl.show({severity: 'error', summary: 'Error.', detail: resp.error});
                }
                this.setState({
                    isLoading: false,
                });
        });
    }

    getNotificationTemplate(){
        if (this.state.notificationList.length > 0){
            return this.state.notificationList.map((item, index) =>
                <div className="p-grid ">
                    <div className="p-col-12" >
                    <Card title={<SubtitleLabel header={item.titulo} isBold={true}/>}
                          footer={
                              <div style={{textAlign: "right"}}>
                                  <Button id={index} label="Aceptar" onClick={this.acceptNotification}/>
                              </div>}
                          style={{padding: "1em"}}>
                        <p className={"secondary-text"}
                           style={{
                               textAlign: "justify",
                               textJustify: "inter-word",
                               whiteSpace: "pre-line",}}>
                            {item.descripcion}</p>
                    </Card><br/>
                    </div>
                </div>

            );
        }
    }

    render() {
        let messagesGrowl = <Growl ref={(el) => this.growl = el}/>;
        let notificationTemplate = this.getNotificationTemplate();
        return (
            <NotificationMessagesView
                isLoading = {this.state.isLoading}
                visibleNotification = {this.state.isNotificationMessage}
                acceptNotification =  {this.acceptNotification}
                notificationTemplate = {notificationTemplate}
                messagesGrowl={messagesGrowl}
                onHide = {this.onHide}
            />
        );
    }
};